/* eslint-disable camelcase */
import WhatsappSessionPreview from './WhatsappSessionPreview'
import WhatsappContentSessionPreviewAdapter from './WhatsappContentSessionPreviewAdapter'
import WhatsappTemplatePreviewAdapter from './WhatsappTemplatePreviewAdapter'
import WhatsappSendContentPreviewAdapter from './WhatsappSendContentPreviewAdapter'
import WhatsappFlowPreviewAdapter from './WhatsappFlowPreviewAdapter'
import ChatbotSessionPreviewAdapter from './ChatbotSessionPreviewAdapter'
import ChatbotTemplatePreviewAdapter from './ChatbotTemplatePreviewAdapter'

export const FORM_PREVIEW_COMPONENTS = {
  session_preview_adapter: WhatsappSessionPreview,
  wa_content_session_preview_adapter: WhatsappContentSessionPreviewAdapter,
  template_preview_adapter: WhatsappTemplatePreviewAdapter,
  wa_send_content_preview_adapter: WhatsappSendContentPreviewAdapter,
  flow_preview_adapter: WhatsappFlowPreviewAdapter,
  chatbot_session_preview_adapter: ChatbotSessionPreviewAdapter,
  chatbot_template_preview_adapter: ChatbotTemplatePreviewAdapter,
}
